module.exports = {
      id: "appinn_logo-usage",
      viewBox: "0 0 141 32",
      url: __webpack_public_path__ + "images/js_src_vue/page_listary_landing/sprite.d9b7df9a.svg#appinn_logo-usage",
      toString: function () {
        return this.url;
      }
    }